module.exports = __webpack_public_path__ + "static/media/Carvel.13741514.svg";